import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGaugeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26.694 17.732",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.838,185.215q.908-1.495,5.712-7.581t5.179-5.873q.32.16-2.563,7.421t-3.684,8.7a2.347,2.347,0,0,1-3.63.961,2.381,2.381,0,0,1-1.014-3.63h0m2.509-10.144a9.875,9.875,0,0,0-7.581,3.39,11.86,11.86,0,0,0-3.1,8.3,10.621,10.621,0,0,0,.053,1.228,1.219,1.219,0,0,1-.32.988,1.4,1.4,0,0,1-.908.454,1.224,1.224,0,0,1-.961-.32,1.352,1.352,0,0,1-.48-.908q0-.214-.027-.694T0,186.763a14.423,14.423,0,0,1,3.871-10.2,12.441,12.441,0,0,1,9.476-4.164,12.781,12.781,0,0,1,3.577.48l-1.869,2.3q-1.068-.107-1.708-.107h0m9.663,1.655a14.5,14.5,0,0,1,3.684,10.037q0,1.014-.053,1.495a1.342,1.342,0,0,1-.427.881,1.285,1.285,0,0,1-.908.347H25.2a1.506,1.506,0,0,1-.934-.534,1.271,1.271,0,0,1-.294-.961,9.806,9.806,0,0,0,.053-1.228,12.451,12.451,0,0,0-2.136-7.154q.16-.374.534-1.361t.587-1.522h0",
		transform: "translate(0 -171.754)"
	})
});
export default SvgGaugeIcon;
